import { HttpBackend, HttpClient } from '@angular/common/http';
import { Injectable, DestroyRef } from '@angular/core';
import { readContract, signTypedData } from '@wagmi/core';
import { firstValueFrom, map, Observable } from 'rxjs';
import { StorageService } from 'src/app/services/storage.service';
import { environment } from 'src/environments/environment';
import { encodeFunctionData, formatEther, getAddress } from 'viem';
import Web3 from 'web3';
import { wagmi_config } from '../core/wagmi/config';
import { AccountState, DigitalAssetValuesResponse, IApiResponse, walletAccount } from '../shared/interface/interface';
import { ContractCommonServiceService } from './contract-common-service.service';
import { publicClientConfig } from './publicClientConfig.service';
import { AppkitService } from '../core/services/appkit.service';
import { SwProcessingService } from '../shared/services/sw-processing.service';

const abi = require('../common/abis/factory.json');
const accessAbi = require('../common/abis/access-token.json');
const nftAbi = require('../common/abis/nftAbi.json');

const apiUrl = environment.API_BASE_URL;
const apiUrlV2 = environment.API_BASE_URL_V2;
const apiUrlV3 = environment.API_BASE_URL_V3
const pinataApiUrl = apiUrlV3.replace(/\/$/, '') + '/management/pinata';

@Injectable({
    providedIn: 'root'
})
export class NftManagementService {
    public account: AccountState;
    public contract: any
    public accessContract: any
    public isRegulated: string = '';
    public chainNetwork = (environment as any).CHAIN_ID;
    public web3: Web3 | null = null;
    private publicClient: any;
    private initTimeout: any;

    private normalizeIpfsCid(value: string): string {
        const trimmedValue = (value || '').trim();
        if (!trimmedValue) return trimmedValue;

        try {
            const parsedUrl = new URL(trimmedValue);
            const pathParts = parsedUrl.pathname.split('/').filter(Boolean);
            return pathParts[pathParts.length - 1] || trimmedValue;
        } catch (_) {
            return trimmedValue.replace(environment.BASE_URL, '');
        }
    }

    /**
     * Creates an instance of nft management service.
     */
    constructor(
        private http: HttpClient,
        private storageService: StorageService,
        public handler: HttpBackend,
        public publicClientConfig: publicClientConfig,
        private contractService: ContractCommonServiceService,
        private appkitService: AppkitService,
        private destroyRef: DestroyRef,
        private swProcessingService: SwProcessingService
    ) {
        this.onInit();
        this.destroyRef.onDestroy(() => {
            if (this.initTimeout) {
                clearTimeout(this.initTimeout);
            }
        });
    }

    /**
     * init on
     */
    public onInit() {
        if (window.ethereum) {
            this.web3 = new Web3(window.ethereum as any);
        }
        this.initTimeout = setTimeout(() => {
            this.accountConfig();
        }, 1000);

    }

    /**
     * Accounts config
     */
    accountConfig() {
        this.account = this.storageService.getItem('wagmi_new_store') === null ?
            { account: '', chainId: environment.DEFAULT_NETWORK, isConnected: false } :
            JSON.parse(this.storageService.getItem('wagmi_new_store') as any);
            console.log('chainId in service', this.account);
        this.isRegulated = JSON.parse(this.storageService.getItemSession('isRegulated')!);
        if (this.account?.account && this.account?.chainId && this.web3) {
            this.publicClient = this.publicClientConfig.publicClient(this.account.chainId);
            this.contract = new this.web3.eth.Contract(abi, environment[this.account.chainId].FACTORY_ADDRESS);
            this.accessContract = new this.web3.eth.Contract(accessAbi, environment[this.account.chainId].ACCESS_CONTROL_TOKEN);
        }
    }

    /**
    * Creats collection
    * @param {any} data
    */
    public async creatCollection(data: any, walletAddress: string, isLazyMint: boolean) {
        let requiredGas;
        let createCollectionAbi;
        const publicClient = this.publicClientConfig.publicClient(this.account.chainId);
        // if (this.isRegulated) {
        if (isLazyMint) {
            const contractParams = {
                address: environment[this.account.chainId].FACTORY_ADDRESS,
                abi: abi,
                functionName: 'createLazyMintERC721CollectionRegulated',
                args: [data['tokenName'], data['tokenSymbol'], data['description'], data['receiver'], data['attributes'], ['']], //Here We Pass The Empty Array of string for the last one there is no use of the last one.
            }

            requiredGas = await publicClient.estimateContractGas({
                address: environment[this.account.chainId].FACTORY_ADDRESS,
                account: walletAddress,
                ...contractParams
            });


            createCollectionAbi = await encodeFunctionData({
                ...contractParams
            })
        } else {
            const contractParams = {
                address: environment[this.account.chainId].FACTORY_ADDRESS,
                abi: abi,
                functionName: 'createERC721CollectionRegulated',
                args: [data['tokenName'], data['tokenSymbol'], data['description'], data['receiver'], data['attributes'], false],
            }

            requiredGas = await publicClient.estimateContractGas({
                address: environment[this.account.chainId].FACTORY_ADDRESS,
                account: walletAddress,
                ...contractParams
            });
            createCollectionAbi = await encodeFunctionData({
                ...contractParams
            })
        }
        // }
        // if (!this.isRegulated) {
        //     if (isLazyMint) {

        //         const contractParams = {
        //             address: environment[this.account.chainId].FACTORY_ADDRESS,
        //             abi: abi,
        //             functionName: 'createLazyMintERC721CollectionUnregulated',
        //             args: [data['tokenName'], data['tokenSymbol'], data['description'], data['receiver'], data['attributes'], ['']], //Here We Pass The Empty Array of string for the last one there is no use of the last one.
        //         }

        //         requiredGas = await this.publicClient.estimateContractGas({
        //             address: environment[this.account.chainId].FACTORY_ADDRESS,
        //             account: walletAddress,
        //             ...contractParams
        //         });

        //         createCollectionAbi = await encodeFunctionData({
        //             ...contractParams
        //         })
        //     }
        //     else {


        //         const contractParams = {
        //             address: environment[this.account.chainId].FACTORY_ADDRESS,
        //             abi: abi,
        //             functionName: 'createERC721CollectionUnregulated',
        //             args: [data['tokenName'], data['tokenSymbol'], data['description'], data['receiver'], data['attributes']],
        //         }
        //         requiredGas = await this.publicClient.estimateContractGas({
        //             address: environment[this.account.chainId].FACTORY_ADDRESS,
        //             account: walletAddress,
        //             ...contractParams
        //         });

        //         createCollectionAbi = await encodeFunctionData({
        //             ...contractParams
        //         })


        //     }
        // }
        requiredGas = requiredGas.toString() as any
        return { createCollectionAbi, requiredGas }
    }


    /**
     * Sets collection attributes
     * @param {string} accountAddress
     * @param {string} collectionAddress
     * @param {array} attributes
     * @returns
     */
    public async setCollectionAttributes(accountAddress: string, collectionAddress: string, attributes: Array<any>) {
        const publicClient = this.publicClientConfig.publicClient(this.account.chainId);
        const contractParams = {
            address: environment[this.account.chainId].FACTORY_ADDRESS,
            abi: abi,
            functionName: 'setCollectionAttributes',
            args: [collectionAddress, attributes],
        }
        const createAttributesAbi = await encodeFunctionData({
            ...contractParams
        })

        let requiredGas = await publicClient.estimateContractGas({
            address: environment[this.account.chainId].FACTORY_ADDRESS,
            account: accountAddress,
            ...contractParams
        });

        requiredGas = requiredGas.toString() as any

        return { createAttributesAbi, requiredGas }
    }

    /**
     * Gets user created collections
     * @param {string} accountAddress
     * @returns
     */
    public async getUserCreatedCollections(accountAddress: string) {

        // Hide the below procees because of the contract side issue while getting the empty collection.
        const chainId = this.account.chainId;
        return await readContract(this.appkitService.adapter.wagmiConfig, {
            address: environment[this.account.chainId].FACTORY_ADDRESS,
            abi: abi,
            chainId: Number(chainId),
            functionName: 'getUserCreatedCollections',
            args: [accountAddress]
        });
        // return new Promise<any>((resolve, reject) => {
        //     this.getCollectionUseAddress(accountAddress).subscribe({
        //         next: (response: any) => {
        //             resolve(response.data)
        //         },
        //         error: (error: any) => {
        //             reject(error)
        //         }
        //     })
        // })

    }


    /**
     * Gets creator
     * @param {number} tokenId
     * @param {string} collectionAddress
     * @returns
     */
    public async getCreator(tokenId: number, collectionAddress: string) {
        const chainId = this.account.chainId;
        return await readContract(this.appkitService.adapter.wagmiConfig, {
            address: await getAddress(collectionAddress),
            abi: nftAbi,
            chainId: Number(chainId),
            functionName: 'creator',
            args: [tokenId]
        });
    }

    /**
     * Fetches available NFT categories used by admin and marketplace flows.
     */
    getCategories() {
        return this.http.get(`${environment.API_BASE_URL_V3}management/nft-traits/categories`)
    }

    /**
     * Gets mandatory attributes
     * @returns
     */
    public getNftTriats(category: string = '', isLazyMint: boolean = false) {
        return this.http.get(`${(environment as any).API_BASE_URL_V3}management/nft-traits?category=${category}&lazy_mint=${isLazyMint}`);
    }

    /**
     * Gets collection attributes
     * @param {string} collectionAddres
     * @returns
     */
    public async getCollectionAttributes(collectionAddress: string) {
        const chainId = this.account.chainId;
        return await readContract(this.appkitService.adapter.wagmiConfig, {
            address: environment[this.account.chainId].FACTORY_ADDRESS,
            abi: abi,
            chainId: Number(chainId),
            functionName: 'getCollectionAttributes',
            args: [collectionAddress]
        });
        // return await this.contract.methods.getCollectionAttributes(collectionAddress).call();
    }

    /**
     * Whites listed
     * @param {AccountState} accountState
     * @returns
     */
    public async whiteListed(accountState: AccountState) {
        // // await this.accountConfig();
        console.log('Raw accountState.chainId:', accountState.chainId);
        const chainId = String(accountState.chainId); // Explicitly convert to string
        console.log('Chain ID (string):', chainId, 'Typeof chainId:', typeof chainId);
        console.log('Entire environment object:', environment);
        console.log('Environment for chainId:', environment[chainId]);
        return await readContract(this.appkitService.adapter.wagmiConfig , {
            address: environment[chainId].ACCESS_CONTROL_TOKEN,
            abi: accessAbi,
            chainId: accountState.chainId,
            functionName: 'whitelisted',
            args: [accountState.account]
        });

    }

    /**
    * Gets user created collections
    * @param {string} accountAddress
    * @returns
    */
    public async getCollectionName(collectionAddress: string) {
        const chainId = this.account.chainId;
        return await readContract(this.appkitService.adapter.wagmiConfig, {
            address: await getAddress(collectionAddress),
            abi: nftAbi,
            chainId: Number(chainId),
            functionName: 'name',
            args: []
        });
    }

    /**
     * To check the collection is valid and created from our factory
     * @param {string} accountAddress
     * @returns
     */
    public async isValidCollection(collectionAddress: string) {
        const chainId = this.account.chainId;
        try {
            return await readContract(this.appkitService.adapter.wagmiConfig, {
                address: await getAddress(collectionAddress),
                abi: nftAbi,
                chainId: Number(chainId),
                functionName: 'factory',
                args: []
            });
        } catch (e) {
            return '0x0000000000000000000000000000000000000000';
        }
    }

    /**
     * Gets user created collections
     * @param {string} accountAddress
     * @returns
     */
    public async getSymbol(collectionAddress: string) {
        const chainId = this.account.chainId;
        return await readContract(this.appkitService.adapter.wagmiConfig, {
            address: await getAddress(collectionAddress),
            abi: nftAbi,
            chainId: Number(chainId),
            functionName: 'symbol',
            args: []
        });
    }

    /**
     * Creates an NFT by calling the appropriate smart contract function, either for a single mint or a batch mint.
     *
     * @param {string} collectionAddress - The address of the NFT collection contract.
     * @param {string} toAddress - The address to which the NFT(s) will be minted.
     * @param {string | string[]} uri - The URI or an array of URIs pointing to the metadata for the NFT(s).
     * @param {string} walletAddress - The wallet address initiating the transaction.
     * @param {number} platformFee - The platform fee for the transaction.
     */
    public async createNft(collectionAddress: string, signatureData: any, walletAddress: string, platformFee, functionName: string,) {
        const publicClient = this.publicClientConfig.publicClient(this.account.chainId);
        const contractParams = {
            address: await getAddress(collectionAddress),
            abi: nftAbi,
            functionName: functionName,
            args: [signatureData.nftMintRequest, signatureData.signature],
            value: platformFee
        }

        const createNftAbi = await encodeFunctionData({
            ...contractParams
        })

        let requiredGas = await publicClient.estimateContractGas({
            address: await getAddress(collectionAddress),
            account: walletAddress,
            ...contractParams
        });

        requiredGas = requiredGas.toString() as any
        return { createNftAbi, requiredGas }
    }

    /**
     * Creates storage signature
     * @param uris 
     * @param collectionAddress 
     * @param ownerAddress 
     * @param toAddress 
     * @param chainId 
     * @param [isClientSide] 
     * @returns  
     */
    async createStorageSignature(uris: any, collectionAddress: any, ownerAddress: any, toAddress: any, chainId: any,custodyUntil:any, isClientSide: boolean = true, callBack: (signature: any) => any) {
        try {
            let signature;
            const nftMintRequest: any = {
                uris, collectionAddress, ownerAddress, toAddress, chainId,custodyUntil,isClientSide
            }

            const domain: any = {
                name: 'NftMintDetails',
                version: '1',
                chainId: Number(chainId),
                verifyingContract: collectionAddress
            }

            // The named list of all type definitions
            const types: any = {
                NftMintDetails: [
                    {
                        "name": "uris",
                        "type": "string[]"
                    },
                    {
                        "name": "collectionAddress",
                        "type": "address"
                    },
                    {
                        "name": "ownerAddress",
                        "type": "address"
                    },
                    {
                        "name": "toAddress",
                        "type": "address"
                    },
                    {
                        "name": "chainId",
                        "type": "uint256"
                    },
                    {
                        "name": "custodyUntil",
                        "type": "uint256"
                    },
                    {
                        "name": "isClientSide",
                        "type": "bool"
                    }
                ],
            }
            // Marks the wallet signature as running so a new-build update never reloads the
            // page while the wallet prompt is open.
            this.swProcessingService.start();
            try {
                signature = await signTypedData(this.appkitService.adapter.wagmiConfig, {
                    domain,
                    message: nftMintRequest,
                    primaryType: 'NftMintDetails',
                    types,
                    account: ownerAddress
                })
            } finally {
                this.swProcessingService.stop();
            }

            if (signature) callBack({ 'data': { signature, nftMintRequest }, status: true });
        } catch (error) {

            callBack({ 'data': { error }, status: false });
        }
    }

    /**
      * Update NFT
      * @param {string} tokenId
      * @param {string} uri
      * @param {array} tokenId
      */
    public async updateNft(collectionAddress: string, uri: string, tokenId: any, walletAddress: string,date?:any) {
        const publicClient = this.publicClientConfig.publicClient(this.account.chainId);
        const urlAddress = (environment as any).BASE_URL + uri;
        const contractParams = {
            address: await getAddress(collectionAddress),
            abi: nftAbi,
            functionName: 'updateTokenUri',
            args: [tokenId,date,urlAddress],
        }

        const createNftAbi = await encodeFunctionData({
            ...contractParams
        })

        let requiredGas = await publicClient.estimateContractGas({
            address: await getAddress(collectionAddress),
            account: walletAddress,
            ...contractParams
        });

        requiredGas = requiredGas.toString() as any

        return { createNftAbi, requiredGas }
    }

    /**
       * Uploads file
       * @param {file} file
       * @return {httpresponse}
       */
    public uploadFile(file: File) {
        const formData = new FormData();
        formData.append('file', file);
        return this.http
            .post<any>(`${pinataApiUrl}/pin-file-to-ipfs`, formData)
            .pipe(map((response) => response?.data || response));
    }

    /**
     * Pins an image url to IPFS
     * @param {string} url - The image url to be pinned
     * @return {Observable<any>} - The response from the pinata API
     */
    pinImageByUrl(url: string) {
        const body = {
          url: url
        };
        
        return this.http
            .post<any>(`${pinataApiUrl}/pin-by-url`, body)
            .pipe(map((response) => response?.data || response));
      }
      

    /**
      * unpin file
      * @param cid
      * @returns
      */
    public unPinFile(cid: string) {
        const normalizedCid = this.normalizeIpfsCid(cid);
        return this.http
            .delete<any>(`${pinataApiUrl}/unpin/${normalizedCid}`)
            .pipe(map((response) => response?.data || response));
    }
    /**
       * Upload Json
       * @param {object} data
       * @return {Observable}
       */
    public uploadJson(data) {
        return firstValueFrom(
            this.http
                .post<any>(`${pinataApiUrl}/pin-json-to-ipfs`, { data })
                .pipe(map((response) => response?.data || response))
        );
    }

    /**
      * Burns nft
      * @param {string} id
      * @param {string} address
      * @param {string} walletAddress
      */
    public async burnNft(id: string, address: string, walletAddress: string) {
        const publicClient = this.publicClientConfig.publicClient(this.account.chainId);
        const contractParams = {
            address: await getAddress(address),
            abi: nftAbi,
            functionName: 'burn',
            args: [id],
        }
        console.log("contractParams", contractParams);

        const burnAbi = await encodeFunctionData({
            ...contractParams
        })
        console.log("burnAbi", burnAbi);
        let requiredGas = await publicClient.estimateContractGas({
            address: await getAddress(address),
            account: walletAddress,
            ...contractParams
        });

        console.log("requiredGas", requiredGas);
        return { burnAbi, requiredGas }
    }

    /**
     * Encodes the freezeAsset/unfreezeAsset contract call against AccessControl, mirroring
     * UserManagementService.blockUnblockUser() for the equivalent user-block action.
     * @param collectionAddress The NFT's collection (token contract) address.
     * @param tokenId The NFT's token id.
     * @param status true to freeze, false to unfreeze.
     * @param walletAddress The signing admin's wallet address (used for gas estimation).
     */
    public async freezeUnfreezeNft(collectionAddress: string, tokenId: string | number, status: boolean, walletAddress: string) {
        const publicClient = this.publicClientConfig.publicClient(this.account.chainId);
        const contractParams = {
            address: environment[this.account.chainId].ACCESS_CONTROL_TOKEN,
            abi: accessAbi,
            functionName: status ? 'freezeAsset' : 'unfreezeAsset',
            args: [await getAddress(collectionAddress), tokenId]
        };
        const requiredGas = await publicClient.estimateContractGas({
            account: walletAddress,
            ...contractParams
        });

        const freezeUnfreezeAbi = await encodeFunctionData({
            ...contractParams
        });

        return { freezeUnfreezeAbi, requiredGas };
    }

    /**
     * Confirms a freeze/unfreeze to the backend after the on-chain tx has mined, mirroring
     * UserManagementService.blockUser().
     */
    public manageNftFreeze(collectionAddress: string, tokenId: string | number, status: boolean, txData?: any) {
        const data = {
            collection_address: collectionAddress,
            token_id: tokenId,
            is_frozen: status,
            transaction_hash: txData?.transactionHash,
            gas_price: txData?.effectiveGasPrice ? formatEther(txData.effectiveGasPrice.toString()) : undefined,
            block_number: `${txData?.blockNumber}`
        };
        return this.http.patch(`${apiUrlV3}management/manage-nft-freeze`, data);
    }

    /**
       * Owners contract integrations service
       */
    public async owner() {
        const chainId = this.account.chainId;
        return await readContract(this.appkitService.adapter.wagmiConfig, {
            address: environment[this.account.chainId].FACTORY_ADDRESS,
            abi: abi,
            chainId: Number(chainId),
            functionName: 'owner',
            args: []
        });

    }


    /**
     * Gets nftowner
     * @param {string} tokenId
     * @param {string} address
     * @returns
     */
    public async getNftowner(tokenId: string, address: string) {
        const chainId = this.account.chainId;
        return await readContract(this.appkitService.adapter.wagmiConfig, {
            address: await getAddress(address),
            abi: nftAbi,
            chainId: Number(chainId),
            functionName: 'ownerOf',
            args: [tokenId]
        });
    }

    /**
     * Gets next mintable token
     * @param {string} address
     * @returns
     */
    public async getNextMintableToken(address: string) {
        const chainId = this.account.chainId;
        return await readContract(this.appkitService.adapter.wagmiConfig, {
            address: await getAddress(address),
            abi: nftAbi,
            chainId: Number(chainId),
            functionName: 'getNextMintableToken',
            args: []
        });
    }

    /**
       * Gets nft details
       * @param {string} url
       * @returns
       */
    public getNftDetails(url: string) {
        const httpClientNew = new HttpClient(this.handler);
        return httpClientNew.get(url);
    }


    /**
       * Gets nft
       * @param {string} address
       * @param {string} id
       * @returns
       */
    public async getNft(address: string, id: string) {
        const chainId = this.account.chainId;
        return await readContract(this.appkitService.adapter.wagmiConfig, {
            address: await getAddress(address),
            abi: nftAbi,
            chainId: Number(chainId),
            functionName: 'tokenURI',
            args: [id]
        });
    }

    /**
       * Platforms fee
       */
    public async platformFee() {
        const chainId = this.account.chainId;
        return await readContract(this.appkitService.adapter.wagmiConfig, {
            address: environment[this.account.chainId].FACTORY_ADDRESS,
            abi: abi,
            chainId: Number(chainId),
            functionName: 'platformFee',
            args: []
        });
    }

    /**
       * Collections platform fee
       * @param {string} collectionAddress
       */
    public async collectionPlatformFee(collectionAddress: string) {
        const chainId = this.account.chainId;
        console.log('admin account', this.account);
        return await readContract(this.appkitService.adapter.wagmiConfig, {
            address: await getAddress(collectionAddress),
            abi: nftAbi,
            chainId: Number(chainId),
            functionName: 'platformFee',
            args: []
        });
    }

    /**
       * Collection Destroyed
       * @param {string} collectionAddress
       */
    public async isCollectionDestroyed(collectionAddress: string) {
        const chainId = this.account.chainId;
        return await readContract(this.appkitService.adapter.wagmiConfig, {
            address: environment[this.account.chainId].FACTORY_ADDRESS,
            abi: abi,
            chainId: Number(chainId),
            functionName: 'isCollectionDestroyed',
            args: [collectionAddress]
        });

    }


    /**
     * Params nft management service
     * @param clientAddress 
     * @param [isLazyMint]
     * Based On The Status We Get The Fee Details.
     * @returns  
     */
    public async royaltyFee(clientAddress: string, isLazyMint: boolean = false) {
        const chainId = this.account.chainId;
        console.log('chainId---', chainId);
        return await readContract(this.appkitService.adapter.wagmiConfig, {
            address: environment[this.account.chainId].FACTORY_ADDRESS,
            abi: abi,
            chainId: Number(chainId),
            functionName: 'getFees',
            args: [clientAddress, isLazyMint]
        });
    }

    /**
       * Royaltys fee
       * @param {string} collectionAddress
       * @returns
       */
    public async collectionRoyaltyFee(collectionAddress: string): Promise<any> {
        const chainId = this.account.chainId;
        return await readContract(this.appkitService.adapter.wagmiConfig, {
            address: await getAddress(collectionAddress),
            abi: nftAbi,
            chainId: Number(chainId),
            functionName: 'royaltyFee',
            args: []
        });
    }

    /**
      * Get total supply
      * @param {string} collectionAddress
      * @returns
      */
    public async getTotalSupply(collectionAddress: string) {
        const chainId = this.account.chainId;
        return await readContract(this.appkitService.adapter.wagmiConfig, {
            address: await getAddress(collectionAddress),
            abi: nftAbi,
            chainId: Number(chainId),
            functionName: 'totalSupply',
            args: []
        });
    }

    /**
       * Get collection owner
       * @param {string} collectionAddress
       * @returns
       */
    public async getCollectionOwner(collectionAddress: string) {
        const chainId = this.account.chainId;
        return await readContract(this.appkitService.adapter.wagmiConfig, {
            address: await getAddress(collectionAddress),
            abi: nftAbi,
            chainId: Number(chainId),
            functionName: 'owner',
            args: []
        });
    }


    /**
     * Get an onboard-asset deposit by id, for prefilling the mint form.
     *
     * @param {string} id - onboard asset id
     * @returns {Observable<any>} An Observable of the server's response
     */
    getOnboardAsset(id: string) {
        return this.http.get(`${apiUrlV3}management/onboard-asset`, {
          params: { id }
        });
    }

    /**
     * Sends a POST request to activate a collection.
     * This API call acts as a failsafe mechanism in case the activation process through indexed events fails.
     *
     * @param {IActivateCollection} data - The data required to activate the collection.
     * @returns {Observable<any>} An Observable of the server's response.
     */
    public activateCollection(data: IActivateCollection) {
        return this.http.post(`${apiUrlV3}management/activate-collection`, data);
    }

    /**
       * Creates collection in DB
       * @param {object} data
       * @returns
       */
    public createCollectionDb(data: object) {
        return this.http.post(`${apiUrlV3}management/collection`, data);
    }

    /**
     * Updates collection db
     * @param {object} data
     * @param {string} id
     * @returns
     */
    public updateCollectionDb(data: object, id: string) {
        return this.http.patch(`${apiUrlV3}management/collection?id=${id}`, data);
    }


    /**
     * Gets collection from db
     * @param {string} adress
     * @returns
     */
    public getCollectionDb(adress: string) {
        return this.http.get(`${apiUrlV3}management/collection-by-address?address=${adress}`);
    }
    /**
     * Gets collection by address
     * @param {string} adress
     * @returns
     */
    public getCollectionByAddress(adress: string) {
        return this.http.get(`${apiUrlV3}management/get-collection?address=${adress}`);
    }

    /**
     * Royaltys release search
     * @param {string} adress
     * @param {string} wallet_address
     * @returns
     */
    public royaltyReleaseSearch(adress: string, wallet_address: string) {
        return this.http.get(`${apiUrlV3}management/search-royalty-release-collection?collection_address=${adress}&wallet_address=${wallet_address}`);
    }


    /**
     * Creates NFT in DB
     * @param {object} data
     * @returns
     */
    public createNftDb(data: object) {
        return this.http.post(`${apiUrlV3}management/nft`, data);
    }

    /**
     * Updates nft db
     * @param {object} data
     * @param {string} token_id
     * @param {string} collection_address
     * @returns
     */
    public updateNftDb(data: object, token_id: string, collection_address: string) {
        return this.http.patch(`${apiUrlV3}management/nft/update-by-token-id?token_id=${token_id}&collection_address=${collection_address}`, data);
    }

    /**
     * Delete NFT
     * @param {string} token_id
     * @param {string} collection_address
     * @param {string} wallet_address
     */
    public deleteNft(deliveryId: string, token_id: string, collection_address: string, wallet_address: string, transaction_hash: string, gas_price: string, block_number: string) {
        return this.http.delete(`${apiUrlV3}management/nft/delete-by-token-id?token_id=${token_id}&collection_address=${collection_address}&wallet_address=${wallet_address}&delivery_id=${deliveryId}&transaction_hash=${transaction_hash}&gas_price=${gas_price}&block_number=${block_number}`);
    }

    /**
      * Validates csv file
      * @param {object} data
      */
    public validateCollection(data: object) {
        return this.http.post(`${apiUrlV3}management/validate-api`, data);
    }

    /**
       * Update collection description
       * @param {string} accountAddress
       * @param {string} collectionAddress
       * @param {string} description
       * @returns
       */
    public async updateCollectionDescription(accountAddress: string, collectionAddress: string, description: string) {
        // NOTE: this method encodes and estimates purely through viem below, so it must not
        // depend on `this.web3` — that is only populated when a wallet extension injects
        // `window.ethereum`. On WalletConnect sessions (iOS Safari and any mobile browser)
        // it stays null, and gating on it here blocked every description update.
        const publicClient = this.publicClientConfig.publicClient(this.account.chainId);
        const contractParams = {
            address: await getAddress(collectionAddress),
            abi: nftAbi,
            functionName: 'updateCollectionDescription',
            args: [description],
        }
        const createAttributesAbi = await encodeFunctionData({
            ...contractParams
        })

        let requiredGas = await publicClient.estimateContractGas({
            address: await getAddress(collectionAddress),
            account: accountAddress,
            ...contractParams
        });
        requiredGas = requiredGas.toString() as any

        return { createAttributesAbi, requiredGas }
    }

    /**
       * Gets admin
       * @param {string} collectionAddress
       * @returns
       */
    public async getAdmin(collectionAddress: string) {
        const chainId = this.account.chainId;
        return await readContract(this.appkitService.adapter.wagmiConfig, {
            address: await getAddress(collectionAddress),
            abi: nftAbi,
            chainId: Number(chainId),
            functionName: 'admin',
            args: []
        });

    }

    /**
     * Checks burn nft
     * @param tokenId
     * @param collectionAddress
     * @returns
     */
    public checkBurnNft(collectionAddress, tokenId) {
        return this.http.get(`${apiUrlV3}management/check-burn-nft-status?address=${collectionAddress}&token_id=${tokenId}`);
    }

    /**
     * Resolves an NFT by collection address + token id for the Freeze Asset lookup form,
     * mirroring checkBurnNft() above.
     * @param collectionAddress
     * @param tokenId
     */
    public checkFreezeNft(collectionAddress, tokenId) {
        return this.http.get(`${apiUrlV3}management/check-freeze-nft-status?address=${collectionAddress}&token_id=${tokenId}`);
    }

    /**
     * Gets collections by address
     * @param {number} page
     * @param {number} limit
     * @param {string} walletAddress
     * @param {string} collectionAddress
     */
    getCollectionsByAddress(
        page: number,
        limit: number,
        walletAddress: string,
        search: string = '',
        typeFilter: 'all' | 'normal' | 'lazy' = 'all',
        sortBy: string = '',
        sortOrder: 'asc' | 'desc' = 'desc',
        exportAll: boolean = false,
        statusFilter: '' | 'with_items' | 'without_items' = '',
        collectionId: string = ''
    ) {
        const params = new URLSearchParams({
            address: walletAddress,
            search,
            sort_by: sortBy,
            sort_order: sortOrder,
            type_filter: typeFilter,
            export_all: String(exportAll),
            status_filter: statusFilter
        });

        if (collectionId) {
            params.set('collection_id', collectionId);
        }

        if (!exportAll) {
            params.set('page', String(page));
            params.set('limit', String(limit));
        }

        return this.http.get(`${apiUrlV3}management/collection-list/wallet?${params.toString()}`);
    }

    /**
     * Gets collections
     * @param {string} address
     * @returns
     */
    getCollections(address: string) {
        return this.http.get(`${apiUrlV3}management/collection-list/owner?address=${address}`);
    }

    /**
     * A collection's assets of every owner for the bulk storage-fee page, with custody date,
     * status, storage rate and whether each can be paid.
     * @param collectionAddress - the collection contract
     * @param status - 'all', 'expired' or 'due-soon'
     */
    getStorageFeeItems(collectionAddress: string, status: string = 'all', search: string = '', page: number = 1, limit: number = 20) {
        const params = new URLSearchParams({ status, search, page: String(page), limit: String(limit) });
        return this.http.get(`${apiUrlV3}management/collections/${collectionAddress}/storage-fee-items?${params.toString()}`);
    }

    /**
     * Records a mined bulk storage-fee payment: the backend reads the payment from the transaction,
     * extends each paid asset and books the fee.
     * @param data - { transaction_hash, currency_id, fee_collector_wallet, block_number?, gas_price?, items: [{ nft_id, amount }] }
     */
    recordBulkStorageFee(data: any) {
        return this.http.patch(`${apiUrlV3}management/nft/expired-dates`, data);
    }


    /**
     * A customer's own collections: the ones created for them (`owner_address`), holdings not
     * counted. Matched server-side, so unlike `getCollectionsByAddress` - which lists collections
     * for an operator, a page at a time - nothing is missed for falling outside the first page.
     *
     * `address` here is the customer's wallet, not the operator's.
     * @param {string} address
     * @returns
     */
    getCollectionsForCustomer(address: string) {
        return this.http.get(`${apiUrlV3}management/collection-list/customer?address=${address}`);
    }

    /**
     * Gets nftby collections
     * @param {string} collectionId
     * @param {string} lazy_mint
     * @param {number} page
     * @param {number} limit
     * @returns
     */
    getNftbyCollections(
        collectionId: string,
        lazy_mint: string,
        page: number = 1,
        limit: number = 10,
        search: string = '',
        sortBy: string = 'created_at',
        sortOrder: 'asc' | 'desc' = 'desc',
        exportAll: boolean = false
    ) {
        const params = new URLSearchParams({
            id: collectionId,
            lazy_mint: lazy_mint || '',
            search: search || '',
            sort_by: sortBy,
            sort_order: sortOrder,
            export_all: String(exportAll)
        });

        if (!exportAll) {
            params.set('page', String(page));
            params.set('limit', String(limit));
        }

        return this.http.get(`${apiUrlV3}management/nft-list-by-collection?${params.toString()}`);
    }

    /**
     * Which of the given items already have a Monetary Metals account attached.
     * The response carries the account name and a flag only — never the account number,
     * which stays server side.
     * @param {string[]} nftIds
     * @return{Observable<IApiResponse>}
     */
    getGoldLeaseAccounts(nftIds: string[]) {
        const ids = (nftIds || []).filter(Boolean).join(',');
        return this.http.get(`${apiUrlV3}management/gold-lease/accounts?nft_ids=${encodeURIComponent(ids)}`);
    }

    /**
     * Attaches a Monetary Metals account to a gold lease item. The backend checks the account
     * actually holds the ounces the item claims before saving, so a rejection here is a real
     * mismatch and its message is worth showing verbatim.
     * @param {string} nftId
     * @param {string} accountNumber  as typed; dashes are stripped server side
     * @return{Observable<IApiResponse>}
     */
    attachGoldLeaseAccount(nftId: string, accountNumber: string) {
        return this.http.post(`${apiUrlV3}management/gold-lease/account`, {
            nft_id: nftId,
            account_number: accountNumber
        });
    }

    /**
     * Detaches the account from an item. The record is kept and marked deleted, so attaching a
     * different account later leaves the earlier one readable.
     * @param {string} nftId
     * @return{Observable<IApiResponse>}
     */
    removeGoldLeaseAccount(nftId: string) {
        return this.http.delete(`${apiUrlV3}management/gold-lease/account?nft_id=${encodeURIComponent(nftId)}`);
    }

    /**
     * Gets nfts by category
     * @param {string} categoryName
     * @param {string} lazyMint
     * @param {number} page
     * @param {number} limit
     * @param {string} searchKey
     * @param {string} order
     * @return{Observable<IApiResponse>}
     */
    getNftsbyCategory(
        categoryName: string,
        lazyMint: string = '',
        page: number,
        limit: number,
        searchKey: string,
        order: string,
        exportAll: boolean = false,
        sortBy: string = '',
        collectionId: string = ''
    ): Observable<IApiResponse> {
        const params = new URLSearchParams({
            category: categoryName,
            lazy_mint: lazyMint,
            search: searchKey,
            order,
            export_all: String(exportAll)
        });

        if (sortBy) {
            params.set('sort_by', sortBy);
            params.set('sort_order', order);
        }

        if (collectionId) {
            params.set('collection_id', collectionId);
        }

        // For export requests, page/limit are intentionally omitted so backend decides full dataset.
        if (!exportAll) {
            params.set('page', String(page));
            params.set('limit', String(limit));
        }

        return this.http.get<IApiResponse>(`${apiUrlV3}management/nft-list-by-category?${params.toString()}`);
    }

    /**
     * stores selected nfts under category which  will be listed in market palce by default
     * @param {string[]} selectedNftIds
     * @param {string} categoryName
     * @return{Observable<IApiResponse>}
     */
    public storeDefaultNftsinCategory(selectedNftIds: string[], categoryName: string): Observable<IApiResponse> {
        let payload = { nftIds: selectedNftIds, category: categoryName };
        return this.http.patch<IApiResponse>(`${apiUrlV3}management/update-selected-nfts`, payload);
    }

    /**
     * removes selected nfts under category which is listed in market palce by default
     * @param {string[]} selectedNftIds
     * @return{Observable<IApiResponse>}
     */
    public removeDefaultNftsinCategory(selectedNftIds: string[]): Observable<IApiResponse> {
        let payload = { nftIds: selectedNftIds }
        return this.http.patch<IApiResponse>(`${apiUrlV3}management/remove-selected-nfts`, payload);
    }

    /**
     * Gets selected nfts under specific category
     * @param {string}categoryName
     * @returns
     */
    getSelectedNftsInCategory(categoryName: string, lazyMint: string = '', page: number, limit: number): Observable<IApiResponse> {
        return this.http.get<IApiResponse>(`${apiUrlV3}management/selected-nft-list?category=${categoryName}&lazy_mint=${lazyMint}&page=${page}&limit=${limit}`);
    }

    /**
     * Gets single nft
     * @param collectionAddress
     * @param tokenId
     * @returns
     */
    getSingleNft(collectionAddress: string, tokenId: string) {
        return this.http.get(`${apiUrlV3}management/get-nft?collection_address=${collectionAddress}&token_id=${tokenId}`);
    }

    /**
     * Gets gold value
     * @param {object} data
     * @returns
     */
    public getGoldValue(data: object) {
        return firstValueFrom(this.http.get(`${(environment as any).API_BASE_URL_V3}market-place/get-gold-value`, data));
    }

    /**
     * Gets gold value
     * @param {object} data
     * @returns
     */
    public _getMetalPrice(weight: number = 0, mark_up_fee: number = 0) {
        const query = `?weight=${weight}&markup_fee_percentage=${mark_up_fee}`
        return firstValueFrom(this.http.get(`${(environment as any).API_BASE_URL_V3}management/get-metal-values${weight == 0 ? '' : query}`));
    }

    /**
     * Live Digital Assets prices. With a quantity, each Type also carries `appraisal_value`
     * (quantity × price, computed by the backend — the dApp never does the money math).
     * @param {string} [quantity] - coin amount, e.g. "0.001"
     * @returns {Promise<DigitalAssetValuesResponse>}
     */
    public getDigitalAssetValues(quantity?: string): Promise<DigitalAssetValuesResponse> {
        const query = quantity ? `?quantity=${encodeURIComponent(quantity)}` : '';
        return firstValueFrom(this.http.get<DigitalAssetValuesResponse>(`${(environment as any).API_BASE_URL_V3}management/get-digital-asset-values${query}`));
    }

    /**
     *
     * @param{string} media
     * @return{Promise}
     */
    async getImage(media: string) {
        const response = await fetch(media);

        if (!response.ok) {
            throw new Error(`Unable to fetch image from ${media}. Request failed with status ${response.status}.`);
        }

        const blob = await response.blob();

        return {
            contentType: response.headers.get("Content-Type"),
            raw: blob
        };
    }

    /**
       * get partner emails to send the delivery updates
       */
    getPartnerEmail(): Observable<IApiResponse> {
        return this.http.get<IApiResponse>(`${apiUrlV3}management/partner-email`);

    }
    /**
     * Based On The User Wallet Address Get The Collection Address
     * @param walletAddress 
     * @returns  
     */
    getCollectionUseAddress(walletAddress: string) {
        return this.http.get(`${apiUrlV3}management/user-collections?address=${walletAddress}`);
    }

    /**
     * Gets apprisal value list
     * @param [nft_id] 
     * @returns  
     */
    getApprisalValueList(nft_id: string = '', page: number = 1, limit = 10, search: string = '', sortBy: string = '', sortOrder: 'asc' | 'desc' = 'desc',
        filters: { method?: string; fromDate?: string; toDate?: string } = {}) {
        const searchParam = search ? `&search=${encodeURIComponent(search)}` : '';
        const sortParams = sortBy ? `&sort_by=${sortBy}&sort_order=${sortOrder}` : '';
        // Method (minted / purchase / updated / bid) and entry date range, sent only when set.
        const filterParams = (filters.method ? `&method=${encodeURIComponent(filters.method)}` : '')
            + (filters.fromDate ? `&from_date=${filters.fromDate}` : '')
            + (filters.toDate ? `&to_date=${filters.toDate}` : '');
        return this.http.get(`${apiUrlV3}management/item-appraisal-history?id=${nft_id}&page=${page}&limit=${limit}${searchParam}${sortParams}${filterParams}`)
    }

    /**
     * Handles delete appriasal value list
     * @param id 
     * @returns  
     */
    handleDeleteAppriasalValueList(id: any) {
        return this.http.delete(`${apiUrlV3}management/item-appraisal-history/remove?id=${id}`)
    }

    /**
     * Gets all burn nfts
     * @returns  
     */
    getAllBurnNfts(
        id: string = '',
        page: number = 1,
        limit = 10,
        search: string = '',
        lazyMint: '' | 'false' | 'true' = '',
        exportAll: boolean = false,
        sortBy: string = '',
        sortOrder: 'asc' | 'desc' = 'desc'
    ) {
        const params = new URLSearchParams({
            id,
            search,
            lazy_mint: lazyMint,
            export_all: String(exportAll)
        });

        if (sortBy) {
            params.set('sort_by', sortBy);
            params.set('sort_order', sortOrder);
        }

        if (!exportAll) {
            params.set('page', String(page));
            params.set('limit', String(limit));
        }

        return this.http.get(`${apiUrlV3}management/burn-nfts-list?${params.toString()}`);
    }

    /**
     * Gets all currently-frozen NFTs, mirroring getAllBurnNfts() above.
     */
    getAllFrozenNfts(
        id: string = '',
        page: number = 1,
        limit = 10,
        search: string = '',
        lazyMint: '' | 'false' | 'true' = '',
        exportAll: boolean = false,
        sortBy: string = '',
        sortOrder: 'asc' | 'desc' = 'desc'
    ) {
        const params = new URLSearchParams({
            id,
            search,
            lazy_mint: lazyMint,
            export_all: String(exportAll)
        });

        if (sortBy) {
            params.set('sort_by', sortBy);
            params.set('sort_order', sortOrder);
        }

        if (!exportAll) {
            params.set('page', String(page));
            params.set('limit', String(limit));
        }

        return this.http.get(`${apiUrlV3}management/frozen-nfts-list?${params.toString()}`);
    }


    /**
     * Gets location
     * @returns  
     */
    getLocation() {
        return this.http.get(`${apiUrlV3}management/location-list`);
    }

    /**
     * Gets storage fee details from marketplace by location and category
     *
     * Used by Manage Inventory to calculate "Storage Fee Overdue Amount"
     * per item using the admin-configured fee for the exact location+category pair.
     * @param location
     * @param category
     * @returns
     */
    getStorageFeeDetailsForMarketplace(location: string, category: string) {
        const params = new URLSearchParams({ location, category });
        return this.http.get(`${apiUrlV3}market-place/storage-fees?${params.toString()}`);
    }

    /**
     * Gets nft list location
     * @param location 
     * @param [page] 
     * @param [limit] 
     * @returns  
     */
    getNftListLocation(
        location: string,
        page: number = 1,
        limit = 10,
        search: string = '',
        sortBy: string = '',
        order: 'asc' | 'desc' = 'desc',
        overdueOnly: boolean = true,
        includeSummary: boolean = true,
        categories: string[] = [],
        pledgeStatuses: string[] = [],
        isBurned: string = '',
        collections: string[] = [],
        ownerAddress: string = '',
        isFrozen: string = '',
        lazyMint: string = ''
    ) {
        const queryParams = new URLSearchParams();
        queryParams.set('page', String(page));
        queryParams.set('limit', String(limit));

        if (location) queryParams.set('location', location);
        if (categories?.length) queryParams.set('category', categories.join(','));
        if (pledgeStatuses?.length) queryParams.set('pledge_status', pledgeStatuses.join(','));
        if (isBurned) queryParams.set('is_burned', isBurned);
        if (collections?.length) queryParams.set('collection', collections.join(','));
        if (ownerAddress) queryParams.set('owner', ownerAddress);
        if (isFrozen) queryParams.set('is_frozen', isFrozen);
        if (lazyMint) queryParams.set('lazy_mint', lazyMint);
        if (search) queryParams.set('search', search);
        if (sortBy) {
            queryParams.set('sort_by', sortBy);
            if (order) queryParams.set('order', order);
        }
        if (overdueOnly) queryParams.set('expired_status', 'EXPIRED');
        /*
         * Backend supports skipping summary KPI calculation for faster non-first pages.
         * include_summary=false keeps infinite scroll/page-2+ lightweight.
         */
        queryParams.set('include_summary', includeSummary ? 'true' : 'false');

        return this.http.get(`${apiUrlV3}management/nft-list-by-location?${queryParams.toString()}`);
    }

    /**
     * Downloads full inventory dataset by location with optional search/sort/overdue filters.
     */
    getNftListLocationDownloadAll(
        location: string = '',
        search: string = '',
        sortBy: string = '',
        order: 'asc' | 'desc' = 'desc',
        overdueOnly: boolean = true,
        categories: string[] = [],
        pledgeStatuses: string[] = [],
        isBurned: string = '',
        collections: string[] = [],
        ownerAddress: string = '',
        isFrozen: string = '',
        lazyMint: string = ''
    ) {
        const queryParams = new URLSearchParams();

        if (location) queryParams.set('location', location);
        if (categories?.length) queryParams.set('category', categories.join(','));
        if (pledgeStatuses?.length) queryParams.set('pledge_status', pledgeStatuses.join(','));
        if (isBurned) queryParams.set('is_burned', isBurned);
        if (collections?.length) queryParams.set('collection', collections.join(','));
        if (ownerAddress) queryParams.set('owner', ownerAddress);
        if (isFrozen) queryParams.set('is_frozen', isFrozen);
        if (lazyMint) queryParams.set('lazy_mint', lazyMint);
        if (search) queryParams.set('search', search);
        if (sortBy) {
            queryParams.set('sort_by', sortBy);
            if (order) queryParams.set('order', order);
        }
        if (overdueOnly) queryParams.set('expired_status', 'EXPIRED');

        return this.http.get(`${apiUrlV3}management/nft-list-by-location-download?${queryParams.toString()}`);
    }

    searchUsers(query: string, limit = 10) {
        return this.http.get(`${apiUrlV3}management/users?item=${encodeURIComponent(query)}&limit=${limit}`);
    }
}


export interface IActivateCollection {
    token: string,
    attributes: any,
    regulated: boolean,
    is_lazy_mint: boolean
    client_address: string,
    transaction_hash: string,
    block_number: string,
    gas_price: string,
    collection_id: string
}
